<div class="modal-wrapper">
    <div class="modal-header">
        <h2
            class="modal-title"
            id="exampleModalLabel">
            Link employee
        </h2>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div *ngIf="(allEmployees$ | async)?.length != 0">
            <div class="form-group m-b-2">
                <label>Choose employee</label>
                <div class="d-flex">
                    <div class="ng-autocomplete">
                        <ng-autocomplete
                            [(ngModel)]="chosenEmployee"
                            [data]="actualEmployees"
                            [searchKeyword]="keyword"
                            (selected)="selectEvent($event)"
                            [itemTemplate]="itemTemplate"
                            [customFilter]="fullNameFilter"
                            autocomplete="off"
                            [notFoundTemplate]="notFoundTemplate"
                            placeholder="Choose employee">
                        </ng-autocomplete>

                        <ng-template
                            #itemTemplate
                            let-item>
                            <a [innerHTML]="item.firstName + ' ' + item.lastName"></a>
                        </ng-template>

                        <ng-template
                            #notFoundTemplate
                            let-notFound>
                            <div>+ Add new</div>
                        </ng-template>
                    </div>
                    <button
                        class="button button--outline button--icon m-l-2"
                        (click)="openAddEmployeeModal()">
                        <i class="las la-plus"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            class="button button--primary"
            (click)="addNewEmployees()">
            Link employee
        </button>
    </div>
</div>
